<template>
  <div v-if="loading">
    <LoadingSpinner :active="true" spinner="bar-fade-scale" class="mt-5" />
  </div>
  <div v-else>
    <!-- Show button group which allows to select selectedTab -->
    <div v-if="error" class="mt-3">
      <div class="alert alert-danger">
        <h4 class="text-danger">
          {{ error }}
        </h4>
      </div>
      <a class="btn btn-sm btn-primary" href="#" @click="loadSurveys">
        {{ $t('loading.error.link') }}
      </a>
    </div>
    <div v-else class="card mt-5">
      <div class="card-header d-flex justify-content-center align-items-center">
        <h3>{{ $t('page.results') }}</h3>
      </div>

      <div v-if="surveys.length" class="card-body">
        <SurveysList
          :surveys="surveys"
          :loadAllHistoricalSurveys="loadAllHistoricalSurveys"
          :hasLoadedOlderSurveys="hasLoadedOlderSurveys"
        />
      </div>
      <div v-else class="card-body">
        <h4 class="text-center mb-7">
          {{ $t('results.noSurveys') }}
        </h4>
        <div class="d-flex justify-content-center">
          <button class="btn btn-sm btn-primary" @click="loadSurveys">
            <i class="bi bi-arrow-clockwise me-2"></i>
            <span>
              {{ $t('results.reloadSurveys') }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useSurveysStore } from '@/stores/surveys-store'
import SurveysList from '@/components/SurveysList.vue'
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue'

export default {
  name: 'Surveys',
  components: {
    SurveysList,
    LoadingSpinner
  },
  setup() {
    const surveysStore = useSurveysStore()
    return { surveysStore }
  },
  data() {
    return {
      selectedTab: 'latest_results',
      hasLoadedOlderSurveys: false
    }
  },
  computed: {
    surveys() {
      return this.surveysStore.getSurveys
    },
    loading() {
      return this.surveysStore.loading.surveys
    },
    error() {
      return this.surveysStore.error?.surveys
    }
  },
  watch: {
    surveys() {
      if (!this.surveys.length && !this.hasLoadedOlderSurveys) {
        this.loadAllHistoricalSurveys()
      }
    }
  },
  mounted() {
    if (!this.surveys.length) {
      this.loadSurveys({ currentSurveysOnly: true })
    }
  },
  methods: {
    loadSurveys({ currentSurveysOnly = false } = {}) {
      this.surveysStore.loadSurveysAction({ currentSurveysOnly })
    },
    loadAllHistoricalSurveys() {
      this.hasLoadedOlderSurveys = true
      this.surveysStore.loadSurveysAction({ currentSurveysOnly: false })
    }
  }
}
</script>

<script></script>

<style scoped></style>
